<template>
  <v-container fluid class="pa-2">

    <div class="traka">
      <h2 class="naslov">
        {{ $store.state.editItem === 1 ? (company.CompanyName || 'Tvrtka') : 'Nova tvrtka' }}
      </h2>
      <div class="podatak">
        <span v-if="$store.state.editItem === 1">
          {{ company.Activ ? 'aktivna' : 'neaktivna' }}
          <span v-if="company.CompanyVATID"> &middot; OIB {{ company.CompanyVATID }}</span>
        </span>
      </div>
    </div>

    <v-card tile>
      <!-- OSNOVNO -->
      <div class="naslov-kartice">Osnovno</div>
      <div class="tijelo">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field dense outlined hide-details="auto" class="mb-2"
              label="Naziv tvrtke *" v-model="company.CompanyName"
              :rules="[required]"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Kratki naziv *" v-model="company.CompanyNameShort"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Naziv baze (bez razmaka) *" v-model="company.CompanyNameDatabase"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="OIB *" v-model="company.CompanyVATID"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="E-mail *" v-model="company.Companyemail"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Telefon" v-model="company.CompanyPhones"></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field dense outlined hide-details class="mb-2"
              label="Ulica *" v-model="company.CompanyStreet"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Kućni broj" v-model="company.CompanyBuildingNameNumber"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Grad *" v-model="company.CompanyCity"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Poštanski broj" v-model="company.CompanyPostcode"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Država" v-model="company.CompanyState"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Županija" v-model="company.CompanyCountyRegion"></v-text-field>
            <v-checkbox dense hide-details class="mt-1"
              label="Aktivna" v-model="company.Activ"></v-checkbox>
          </v-col>
        </v-row>
      </div>

      <!-- RAČUNI I ISPIS -->
      <div class="naslov-kartice">Računi i ispis</div>
      <div class="tijelo">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-select dense outlined hide-details class="mb-2"
              label="Valuta" :items="currencyType" item-text="text" item-value="value"
              v-model="company.currencyType"></v-select>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Rok plaćanja (dana)" type="number"
              v-model.number="company.CompanyInvoiceDefDays"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Početni broj računa" v-model="company.CompanyStartInvoiceNumber"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Početni broj kase" v-model="company.CompanyStartBillNumber"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field dense outlined hide-details class="mb-2"
              label="Veličina pisača" v-model="company.CompanyPrinterSize"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Zadano skladište" v-model="company.CompanyDefaultWarehouse"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Vrsta računa" v-model="company.CompanyInvoiceType"></v-text-field>
            <v-checkbox dense hide-details class="mt-1"
              label="Nije u sustavu PDV-a" v-model="company.notinVAT"></v-checkbox>
            <v-checkbox dense hide-details
              label="PDV po naplati" v-model="company.CompanyVATonPay"></v-checkbox>
          </v-col>
          <v-col cols="12">
            <v-textarea dense outlined hide-details rows="2" class="mt-2"
              label="Napomena na računu" v-model="company.CompanyInvoiceHint"></v-textarea>
          </v-col>
        </v-row>
      </div>

      <!-- eRAČUN -->
      <div class="naslov-kartice">eRačun</div>
      <div class="tijelo">
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field dense outlined hide-details class="mb-2"
              label="Posrednik (šifra)" type="number"
              v-model.number="company.eRacunProvider"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Naziv posrednika" v-model="company.eRacunProviderName"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Oznaka programa" v-model="company.eRacunSoftwareID"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <!-- Kljuc se ne prikazuje otvoreno: ekran postavki zna ostati otvoren
                 dok netko drugi gleda, a tim kljucem se salju racuni. -->
            <v-text-field dense outlined hide-details class="mb-2"
              label="API ključ" v-model="company.eRacunProviderAPIkey"
              :type="vidiKljuc ? 'text' : 'password'"
              :append-icon="vidiKljuc ? 'mdi-eye-off' : 'mdi-eye'"
              autocomplete="off"
              @click:append="vidiKljuc = !vidiKljuc"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Korisničko ime" v-model="company.eRacunProviderUserName"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Lozinka" v-model="company.eRacunProviderUserPassword"
              :type="vidiLozinku ? 'text' : 'password'"
              :append-icon="vidiLozinku ? 'mdi-eye-off' : 'mdi-eye'"
              autocomplete="new-password"
              @click:append="vidiLozinku = !vidiLozinku"></v-text-field>
            <v-checkbox dense hide-details class="mt-1"
              label="Probni način" v-model="company.eRacunTestMode"></v-checkbox>
          </v-col>
        </v-row>
      </div>

      <!-- RAZMJENA RACUNA MEDJU SERVERIMA -->
      <div class="naslov-kartice">Razmjena računa s drugim serverom</div>
      <div class="tijelo">
        <v-row dense>
          <v-col cols="12">
            <div class="caption grey--text mb-3">
              Istu firmu knjigovodstvo vodi na drugom serveru. Umjesto skidanja XML-a
              s posrednika, računovodstveni server sam povlači izlazne račune s
              klijentovog. Isti ključ upisuje se na OBA servera, a firme se vežu po OIB-u.
              <br>
              <b>Klijentov server</b> (odavde se uzima): upisati samo ključ, adresu ostaviti praznu.
              <br>
              <b>Računovodstveni server</b> (ovdje se povlači): upisati adresu klijentovog
              servera i isti ključ. Tada se u knjizi IRA pojavi gumb „Povuci od klijenta".
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <!-- Preglednik je ovaj par polja (tekst + password) citao kao
                 prijavu i nudio spremljeno korisnicko ime i lozinku. Zato
                 polja imaju svoja imena, a kljuc "new-password" - jedino sto
                 Chrome postuje; "off" zanemaruje. -->
            <v-text-field dense outlined persistent-hint class="mb-2"
              label="Adresa klijentovog servera"
              placeholder="https://app.klijent.hr/backend"
              hint="Prazno = ovo je klijentov server, on samo daje račune."
              name="razmjena-adresa" autocomplete="off" spellcheck="false"
              v-model="company.RazmjenaUrl"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <!-- Kljuc stoji skriven, kao i kljuc posrednika iznad: ekran postavki
                 zna ostati otvoren dok netko drugi gleda. -->
            <v-text-field dense outlined persistent-hint class="mb-2"
              label="Ključ razmjene" v-model="company.RazmjenaKljuc"
              :type="vidiRazmjenu ? 'text' : 'password'"
              :append-icon="vidiRazmjenu ? 'mdi-eye-off' : 'mdi-eye'"
              name="razmjena-kljuc" autocomplete="new-password" spellcheck="false"
              hint="Mora biti isti na oba servera. Bez ključa razmjena ne radi."
              @click:append="vidiRazmjenu = !vidiRazmjenu"></v-text-field>
            <v-btn small text color="primary" class="px-0" @click="noviKljucRazmjene">
              <v-icon small left>mdi-key-plus</v-icon>Generiraj ključ
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- ZADACI I E-MAIL -->
      <div class="naslov-kartice">Zadaci i e-mail</div>
      <div class="tijelo">
        <v-row dense>
          <v-col cols="12" sm="6">
            <!-- Autocomplete, ne v-select: u popisu zna biti dvadesetak ljudi
                 i traze se upisom imena, ne prelistavanjem. -->
            <v-autocomplete dense outlined hide-details class="mb-1"
              :items="zaduzeniKorisnici" v-model="company.CompanyTaskUserId"
              label="Zadužena osoba za zadatke" item-text="naziv" item-value="id"
              clearable @change="postaviZaduzenuOsobu"></v-autocomplete>
            <div class="caption grey--text mb-2">
              <span v-if="company.CompanyTaskUserId">
                Zadatak za ovu firmu bez odabranog izvršitelja ide ovoj osobi.
              </span>
              <span v-else class="orange--text text--darken-3">
                Nitko nije zadužen — zadatak bez izvršitelja ostaje ničiji.
              </span>
            </div>
            <v-text-field dense outlined hide-details class="mb-2"
              label="E-mail zadužene osobe" v-model="company.CompanyTaskEmail"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field dense outlined hide-details class="mb-2"
              label="E-mail računovodstva (prima primke)"
              v-model="company.CompanyAccountingEmail"></v-text-field>
            <v-text-field dense outlined hide-details class="mb-2"
              label="Potpis u e-mail porukama" v-model="company.CompanyMailSignature"></v-text-field>
            <v-checkbox dense hide-details class="mt-1"
              label="Šalji e-mail sa zadatkom" v-model="company.CompanySendEmailTask"></v-checkbox>
            <v-checkbox dense hide-details
              label="Dopusti učitavanje eSLOG računa (BizBox)"
              v-model="company.CompanyEslogImport"></v-checkbox>
          </v-col>
        </v-row>
      </div>

      <!-- Rijetko popunjeno - sklopljeno. Uz svaku skupinu stoji koliko je
           firmi uopce koristi (mjereno na 98 firmi, 13.10.2026.). -->
      <v-expansion-panels flat multiple class="sklopivo">
        <v-expansion-panel>
          <v-expansion-panel-header>
            Direktor <span class="oznaka">39 % firmi</span>
            <template v-slot:actions><v-icon small>mdi-chevron-down</v-icon></template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field dense outlined hide-details class="mb-2" label="Ime"
                  v-model="company.CompanyDirectorFirst"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Prezime"
                  v-model="company.CompanyDirectorLast"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="E-mail"
                  v-model="company.CompanyDirectorEmail"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Telefon"
                  v-model="company.CompanyDirectorPhone"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field dense outlined hide-details class="mb-2" label="Titula"
                  v-model="company.CompanyDirectorTitle"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Datum rođenja"
                  v-model="company.CompanyDirectorDateOfBirth"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Zanimanje"
                  v-model="company.CompanyDirectorBusinessOccupation"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Ulica"
                  v-model="company.CompanyDirectorAdressStreet"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Grad"
                  v-model="company.CompanyDirectorCity"></v-text-field>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel>
          <v-expansion-panel-header>
            Kontakt <span class="oznaka">5 % firmi</span>
            <template v-slot:actions><v-icon small>mdi-chevron-down</v-icon></template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field dense outlined hide-details class="mb-2" label="Ime"
                  v-model="company.CompanySecretaryFirst"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Prezime"
                  v-model="company.CompanySecretaryLast"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="E-mail"
                  v-model="company.CompanySecretaryEmail"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field dense outlined hide-details class="mb-2" label="Telefon"
                  v-model="company.CompanySecretaryPhone"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Grad"
                  v-model="company.CompanySecretaryCity"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Ulica"
                  v-model="company.CompanySecretaryAdressStreet"></v-text-field>
              </v-col>
            </v-row>
            <div class="caption grey--text mt-1">
              Polja su u bazi <code>CompanySecretary…</code>; naziv na ekranu je „Kontakt".
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

                <v-expansion-panel>
          <v-expansion-panel-header>
            Maloprodaja i radno vrijeme <span class="oznaka">26 % firmi</span>
            <template v-slot:actions><v-icon small>mdi-chevron-down</v-icon></template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row dense>
              <v-col cols="12" sm="6">
                <v-text-field dense outlined hide-details class="mb-2" label="Poslovni prostor"
                  v-model="company.CompanyBusinessSpace"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Naplatni uređaj"
                  v-model="company.CompanyBusinessDevice"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Prostor (maloprodaja)"
                  v-model="company.CompanyBusinessSpaceRetail"></v-text-field>
                <v-text-field dense outlined hide-details class="mb-2" label="Uređaj (maloprodaja)"
                  v-model="company.CompanyBusinessDeviceRetail"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-checkbox dense hide-details class="mt-1"
                  label="Maloprodajna cijena" v-model="company.CompanyUseRetailPrice"></v-checkbox>
                <v-checkbox dense hide-details class="mb-2"
                  label="Provjeri radno vrijeme" v-model="company.CompanyRetailWorkCheck"></v-checkbox>
                <div class="d-flex align-center mb-2" style="gap:8px">
                  <v-text-field dense outlined hide-details label="Od" style="max-width:110px"
                    v-model="company.CompanyRetailWorkFrom"></v-text-field>
                  <span>&ndash;</span>
                  <v-text-field dense outlined hide-details label="Do" style="max-width:110px"
                    v-model="company.CompanyRetailWorkTo"></v-text-field>
                </div>
                <v-select dense outlined hide-details multiple chips small-chips
                  label="Radni dani" :items="nazivDana" v-model="radniDani"></v-select>
              </v-col>
            </v-row>
            <div class="caption grey--text mt-1">
              Kad je provjera uključena, kasa ne izdaje račun izvan radnog vremena.
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>

              </v-expansion-panels>

      <v-divider></v-divider>
      <v-card-actions>
        <v-btn text @click="compList">Natrag</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :disabled="!formIsValid" @click="register">Spremi</v-btn>
      </v-card-actions>
    </v-card>

    <div class="caption grey--text mt-2">
      Logo i memorandum uređuju se na zasebnom ekranu („Logo i podaci firme" u postavkama).
    </div>

    <v-snackbar v-model="snackbar" :timeout="timeout" :color="color">
      {{ text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import CompService from '@/services/CompService'
import UserService from '@/services/UserService'
import { prikazKorisnika } from '@/snippets/korisnikPrikaz'

export default {
  name: 'companycreate',
  data () {
    return {
      snackbar: false,
      text: '',
      timeout: 2000,
      color: 'green',
      menu: false,
      modal: false,
      modal1: false,
      dialog1: false,
      msg: '',
      newCompany: {},
      company: {
        CompanyName: '',
        CompanyNameShort: '',
        CompanyNameDatabase: '',
        CompanyBuildingNameNumber: '',
        CompanyStreet: '',
        CompanyCity: '',
        CompanyPostcode: '',
        CompanyCountyRegion: '',
        CompanyState: '',
        CompanyVATID: '',
        Companyemail: '',
        CompanyPhones: '',
        CompanyBankName: '',
        CompanyBankAddress: '',
        CompanyBankIBAN: '',
        CompanyBankSWIFT: '',
        CompanyDirectorTitle: '',
        CompanyDirectorFirst: '',
        CompanyDirectorLast: '',
        CompanyDirectorFormer: '',
        CompanyDirectorStateResidence: '',
        CompanyDirectorNationality: '',
        CompanyDirectorDateOfBirth: '',
        CompanyDirectorBusinessOccupation: '',
        CompanyDirectorAdressBuildingNameNumber: '',
        CompanyDirectorAdressStreet: '',
        CompanyDirectorCity: '',
        CompanyDirectorPostcode: '',
        CompanyDirectorCountyRegion: '',
        CompanyDirectorEmail: null,
        CompanyDirectorPhone: '',
        CompanyDirectorContactOption: '',
        CompanySecretaryTitle: '',
        CompanySecretaryFirst: '',
        CompanySecretaryLast: '',
        CompanySecretaryFormer: '',
        CompanySecretaryStateResidence: '',
        CompanySecretaryNationality: '',
        CompanySecretaryDateOfBirth: '',
        CompanySecretaryBusinessOccupation: '',
        CompanySecretaryAdressBuildingNameNumber: '',
        CompanySecretaryAdressStreet: '',
        CompanySecretaryCity: '',
        CompanySecretaryPostcode: '',
        CompanySecretaryCountyRegion: '',
        CompanySecretaryEmail: null,
        CompanySecretaryPhone: '',
        CompanySecretaryContactOption: '',
        CompanyInvoiceMemo: '',
        CompanyInvoiceForeginMemo: '',
        CompanyDeliveryNoteMemo: '',
        CompanyDeliveryNoteForeginMemo: '',
        CompanyInvoiceDefDays: 15,
        CompanyInvoicePlace: '',
        CompanyInvoiceType: '',
        CompanyInvoiceHint: '',
        CompanyInvoiceSpeed: 1,
        CompanyUseRetailPrice: false,
        CompanyShowLastSaleBuyer: false,
        CompanyShowWarehouseState: false,
        CompanyShowInputPrice: false,
        CompanyVATonPay: false,
        CompanyRetail: false,
        CompanyDefaultWarehouse: 1,
        CompanyPrinterSize: 1,
        CompanyInputFilesPath: '',
        CompanyOutputFilesPath: '',
        CompanyTransferDataFilesPath: '',
        CompanyStartInvoiceNumber: 1,
        CompanyStartBillNumber: 1,
        CompanyType: 1,
        CompanyDescriptionUp: '',
        CompanyDescriptionDown: '',
        CompanyBusinessSpace: '',
        CompanyBusinessDevice: '',
        CompanyBusinessSpaceRetail: '',
        CompanyBusinessDeviceRetail: '',
        CompanyRetailWorkCheck: false,
        CompanyRetailWorkFrom: '08:00',
        CompanyRetailWorkTo: '20:00',
        CompanyRetailWorkDays: '1111110',
        CompanySendEmailTask: false,
        // Osoba zaduzena za zadatke ove firme - vidi "postaviZaduzenuOsobu".
        CompanyTaskUserId: null,
        CompanyTaskEmail: null,
        CompanyAccountingEmail: null,
        CompanyMailSignature: null,
        CompanyEslogImport: false,
        // Razmjena izlaznih racuna s drugim Roboot serverom - vidi
        // "Razmjena racuna s drugim serverom" u formi.
        RazmjenaUrl: null,
        RazmjenaKljuc: null,
        CompanyLogo5: '',
        currencyType: 'EUR',
        InAllaccount4: null,
        InVATaccount4: null,
        InBaseaccount4: null,
        OutAllaccount4: null,
        OutVATaccount4: null,
        OutBaseaccount4: null,
        StartFrom: null,
        Activ: false,
        LastUpdate: null,
        showFooter1: false
      },
      required: (value) => !!value || 'Required.',
      error: '',
      currencyType: [
        { text: 'Kn', value: 'Kn' },
        { text: 'EUR', value: 'EUR' },
        { text: 'USD', value: 'USD' },
        { text: 'GBP', value: 'GBP' },
        { text: 'CHF', value: 'CHF' }
      ],
      account4s: [],
      // Ponedjeljak prvi - isti redoslijed kakav nosi CompanyRetailWorkDays.
      nazivDana: ['Pon', 'Uto', 'Sri', 'Čet', 'Pet', 'Sub', 'Ned'],
      zaduzeniKorisnici: [],
      // Pristupni podaci za eRacun stoje skriveni; oko ih otkriva kad treba.
      vidiKljuc: false,
      vidiLozinku: false,
      vidiRazmjenu: false,
    }
  },
  async mounted () {
    try {
      if (this.$store.state.editItem === 1) {
        const locComp = await CompService.show(this.$store.state.companyid)
        this.company = locComp.data.company
      }
    } catch (error) {
      // eslint-disable-next-line
      console.log('greska kod monut dokumenta', error)
    }
    this.account4s = this.$store.state.account4s ? this.$store.state.account4s : []

    // Popis za odabir zaduzene osobe. Ime i e-mail zajedno, jer u sifrarniku
    // ima istoimenih korisnika. Korisnici su oni iz NASE firme (one u koju je
    // operater prijavljen) - zaduzena osoba radi kod nas, ne kod klijenta.
    try {
      const svi = (await UserService.choose({CompanyId: this.$store.state.companyid})).data.users
      this.zaduzeniKorisnici = (svi || []).map(u => ({
        id: u.id,
        email: u.email,
        naziv: prikazKorisnika(u)
      }))
    } catch (error) {
      // Bez popisa polje ostane prazno; ostatak obrasca radi normalno.
      // eslint-disable-next-line
      console.log('popis korisnika za zaduzenje', error)
    }
  },
  methods: {
    // E-mail se cuva uz Id da se u zadatku vidi kome je isao i kad se korisnik
    // kasnije preimenuje ili ugasi.
    postaviZaduzenuOsobu (id) {
      const nasao = this.zaduzeniKorisnici.find(u => u.id === id)
      this.company.CompanyTaskEmail = nasao ? nasao.email : null
    },
    // Kljuc razmjene je jedina brana na ruti koja daje racune, pa ne smije biti
    // nesto sto se pogodi. Radi se iz crypto-a (Math.random nije za kljuceve),
    // 48 znakova bez slicnih (0/O, 1/l) jer se prepisuje rukom na drugi server.
    noviKljucRazmjene () {
      const znakovi = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789'
      const n = 48
      const bajtovi = new Uint8Array(n)
      window.crypto.getRandomValues(bajtovi)
      let kljuc = ''
      for (let i = 0; i < n; i++) { kljuc += znakovi[bajtovi[i] % znakovi.length] }
      this.$set(this.company, 'RazmjenaKljuc', kljuc)
      this.vidiRazmjenu = true
      this.text = 'Ključ je napravljen — upiši ga i na drugi server'
      this.color = 'green'
      this.snackbar = true
    },
    async register () {
      try {
        if (this.$store.state.editItem === 1) {
          await CompService.put(this.company)
          this.text = 'Company updated'
          this.color = 'green'
          this.snackbar = true
        }
        if (this.$store.state.editItem === 0) {
          await CompService.post(this.company)
          this.text = 'New company saved to database'
          this.color = 'green'
          this.snackbar = true
        }
        // this.$store.dispatch('seteditItem', 0)
        // this.$router.push({
        //   name: 'company'
        // })
      } catch (error) {
        this.error = error.response.data.error
        this.text = 'Error on save'
        this.color = 'red'
        this.snackbar = true
      }
    },
    async compList () {
      try {
        await this.$router.push({
          name: 'company'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  computed: {
    // Radni dani se u bazi drze kao sedam znamenki ("1111110"), jedan znak po
    // danu, ponedjeljak prvi - jedan stupac umjesto sedam, i citljivo u bazi.
    // Na ekranu je to obican odabir s oznakama.
    radniDani: {
      get () {
        const dani = String(this.company.CompanyRetailWorkDays || '')
        return this.nazivDana.filter((naziv, i) => dani.charAt(i) === '1')
      },
      set (odabrani) {
        this.company.CompanyRetailWorkDays = this.nazivDana
          .map(naziv => (odabrani.indexOf(naziv) !== -1 ? '1' : '0'))
          .join('')
      }
    },
    formIsValid () {
      return this.company.CompanyName !== '' &&
        this.company.CompanyNameShort !== '' &&
        this.company.CompanyNameDatabase !== '' &&
        this.company.CompanyVATID !== '' &&
        this.company.Companyemail !== ''
    }
  },
  watch: {
    'company.CompanyName' () {
      if (this.company.CompanyName) {
        this.company.CompanyNameDatabase =  this.company.CompanyName.replace(/[\W_]/g, '')
        this.company.CompanyNameShort = this.company.CompanyName
      }
    }
  }
}
</script>

<style scoped>
.traka {
  background: #0d47a1;
  color: #fff;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  border-radius: 4px 4px 0 0;
}
.naslov { font-size: 18px; font-weight: 500; margin: 0; }
.podatak { margin-left: auto; font-size: 12px; opacity: .9; }

/* Naslov skupine - isti stil kao na ostalim redizajniranim ekranima. */
.naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1565c0;
  padding: 7px 12px;
}
.tijelo { padding: 12px; }

/* Sklopive skupine bez Vuetifyjeve sjene, da izgledaju kao dio kartice. */
.sklopivo >>> .v-expansion-panel-header {
  min-height: 42px;
  padding: 8px 12px;
  font-weight: 500;
  color: #1565c0;
}
.sklopivo >>> .v-expansion-panel { border-top: 1px solid #e3e8ee; }
.sklopivo >>> .v-expansion-panel-content__wrap { padding: 0 12px 12px; }

/* Koliko firmi skupinu uopce koristi - da se odmah vidi sto je mrtvo polje. */
.oznaka {
  font-size: 11px;
  font-weight: 400;
  color: #5f6b7a;
  background: #eceff1;
  padding: 1px 7px;
  border-radius: 9px;
  margin-left: 8px;
}

@media (max-width: 900px) {
  .podatak { width: 100%; margin-left: 0; }
}
</style>
